(function(){
  var TARGET='YC.JG.ZS006786';
  var TARGET_ASSEMBLY='Landing Gear Module 2';
  var TARGET_GROUP='spray';
  var TARGET_ITEMS=['2','6'];
  function norm(v){return String(v||'').trim().toUpperCase();}
  function isTargetRow(row){var n=row&&row.querySelector('.t100parts__material');return !!n&&norm(n.textContent)===TARGET;}

  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var programmatic=false;
    function layers(){return [root.querySelector('[data-t100-hotspots]'),root.querySelector('[data-t100-modal-hotspots]')].filter(Boolean);}
    function setSharedMarkers(on){layers().forEach(function(layer){layer.querySelectorAll('[data-hotspot-item]').forEach(function(marker){marker.classList.toggle('is-shared-selected',!!on&&TARGET_ITEMS.indexOf(String(marker.dataset.hotspotItem))>-1);});});}
    function setSharedContext(){var c=root.querySelector('[data-t100-diagram-sub]');if(c){c.textContent=TARGET+' is used at callouts #2 and #6 on Landing Gear Module 2 (LGM2). Yellow markers show both confirmed locations.';c.dataset.sharedSummary='true';}}
    function clearSharedContext(){
      root.removeAttribute('data-tja-shared-target');
      setSharedMarkers(false);
      var c=root.querySelector('[data-t100-diagram-sub]');
      if(c&&c.dataset.sharedSummary==='true'){delete c.dataset.sharedSummary;var sel=root.querySelector('[data-t100-assembly]');c.textContent=sel&&sel.value?'Spray System':'Choose an assembly to open its exact diagram';}
    }
    function selectTargetRows(scroll){
      var rows=Array.prototype.slice.call(root.querySelectorAll('[data-part-row]'));
      rows.forEach(function(r){if(isTargetRow(r)&&r.dataset.assembly===TARGET_ASSEMBLY)r.classList.add('is-selected');else r.classList.remove('is-selected');});
      setSharedMarkers(true);setSharedContext();
      if(scroll){var first=rows.find(function(r){return isTargetRow(r)&&r.dataset.assembly===TARGET_ASSEMBLY;});if(first)first.scrollIntoView({behavior:'smooth',block:'center'});}
    }
    function activateTarget(destination){
      root.dataset.tjaSharedTarget=TARGET;
      programmatic=true;
      var sys=root.querySelector('.t100parts__system[data-group="'+TARGET_GROUP+'"]');
      if(sys&&!sys.classList.contains('is-active'))sys.click();
      window.setTimeout(function(){
        var sel=root.querySelector('[data-t100-assembly]');
        if(sel){var ok=Array.prototype.some.call(sel.options,function(o){return o.value===TARGET_ASSEMBLY;});if(ok){sel.value=TARGET_ASSEMBLY;sel.dispatchEvent(new Event('change',{bubbles:true}));}}
        window.setTimeout(function(){
          selectTargetRows(destination==='row');
          if(destination!=='row'){var panel=root.querySelector('.t100parts__diagramPanel');if(panel)panel.scrollIntoView({behavior:'smooth',block:'start'});}
          programmatic=false;
        },0);
      },0);
    }

    root.addEventListener('click',function(e){
      var row=e.target.closest('[data-part-row]');
      var targetAction=row&&isTargetRow(row)&&(e.target.closest('[data-view-part]')||e.target.closest('[data-row-item]'));
      if(targetAction){e.preventDefault();e.stopImmediatePropagation();activateTarget('diagram');return;}
      var hot=e.target.closest('[data-hotspot-item]');
      if(root.dataset.tjaSharedTarget===TARGET&&hot&&TARGET_ITEMS.indexOf(String(hot.dataset.hotspotItem))>-1){e.preventDefault();e.stopImmediatePropagation();selectTargetRows(true);return;}
      if(programmatic)return;
      if(row&&!isTargetRow(row))clearSharedContext();
      if(e.target.closest('.t100parts__system')||e.target.closest('.t100parts__clear')||e.target.closest('[data-t100-exit-search]'))clearSharedContext();
    },true);

    var search=root.querySelector('.t100parts__search');if(search)search.addEventListener('input',function(){if(!programmatic&&norm(search.value)!==TARGET)clearSharedContext();},true);
    var sel=root.querySelector('[data-t100-assembly]');if(sel)sel.addEventListener('change',function(){if(!programmatic&&sel.value!==TARGET_ASSEMBLY)clearSharedContext();});

    var observer=new MutationObserver(function(){if(root.dataset.tjaSharedTarget===TARGET)window.requestAnimationFrame(function(){selectTargetRows(false);});});
    var rows=root.querySelector('[data-t100-rows]');if(rows)observer.observe(rows,{childList:true,subtree:true});

    var params=new URLSearchParams(window.location.search);var wanted=norm(params.get('part')||params.get('sku')||params.get('q'));
    if(wanted===TARGET)window.setTimeout(function(){activateTarget('diagram');},80);
  });
})();
